export default class FeaturedPost {
  static get toolbox() {
    return {
      title: "Featured internal post",
      icon: `<i class="fad fa-newspaper"></i>`,
    };
  }

  constructor({ data }) {
    if (data && data.url) this.url = data.url;
    this.input = null;
    this.label = null;
  }

  render() {
    let wrapper = document.createElement("div");
    wrapper.classList.add("proEditorWrapper", 'cdx-block', 'featuredPost');

    // link input
    this.input = document.createElement("input");
    this.input.classList.add('cdx-input', 'featuredPostLink');
    this.input.setAttribute("placeholder", "Input link to featured internal post");
    if (this.url) this.input.value = this.url;
    wrapper.appendChild(this.input);

    this.label = document.createElement("div");
    this.label.classList.add('--text-md', '--text-left', 'text-danger');
    this.label.innerHTML = "&nbsp;";
    wrapper.appendChild(this.label);

    this._checkLinkValidity();
    this.input.addEventListener('keyup', () => this._checkLinkValidity());

    let featuredPost = document.createElement("div");
    featuredPost.classList.add('featuredPost');

    let imageContainer = document.createElement("div");
    imageContainer.classList.add('imageContainer');
    imageContainer.innerHTML = `<i class="fad fa-newspaper"></i>`;
    featuredPost.appendChild(imageContainer);

    let postDetails = document.createElement("div");
    postDetails.classList.add('postDetails');
    postDetails.innerHTML = `
      <h2> Featured Internal Post </h2>
      <p> Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur magna arcu id mauris. Etiam ex massa, vehicula sed dictum sit amet, condimentum malesuada dui. </p>
    `
    featuredPost.appendChild(postDetails);

    wrapper.appendChild(featuredPost);
    return wrapper;
  }

  _checkLinkValidity() {
    let error = "Invalid url. Should contain only letters, numbers and dashes(-).";
    if (this.input.value.match(/^[a-zA-z0-9-]*$/)) error = "&nbsp;";
    this.label.innerHTML = error;
  }

  save(blockContent) {
    let url = blockContent.querySelector('input').value;
    return {
      url,
    };
  }

  static get sanitize() {
    return {
      a: true,
      i: true,
      b: true,
    };
  }
}